// Optional ?next= on /auth/handoff. Follow it only when it is a same-site
// relative path: one leading "/", not "//", and no scheme or backslash.
// Anything else is not a destination.

export function safeSameSitePath(next) {
  if (typeof next !== 'string' || next.length === 0) return null;
  if (next[0] !== '/') return null;
  if (next.startsWith('//')) return null;
  if (next.includes('\\')) return null;
  if (next.includes('://')) return null;
  if (/[a-zA-Z][a-zA-Z0-9+.-]*:/.test(next)) return null;
  if (/[\u0000-\u001F\u007F\s]/.test(next)) return null;
  return next;
}

export function clientHandoffDestination(next) {
  return safeSameSitePath(next) || '/';
}
